import { useMemo, useEffect, useCallback } from 'react';
import { Logger } from 'simple-logging-lib';
import { useStartOnboardingTour } from 'nav-onboarding-tours';
import { MARKETING_STUDIO_TOUR_ID } from 'nav-onboarding-tours/tours';
import { MARKETING_STUDIO_GATE } from '../../../constants/gates';
import { useAppSelector } from '../../../hooks';
import useNavItems from '../../../hooks/useNavItems';
import { selectGates } from '../../../reducers/Portal';
import { selectScopes } from '../../../selectors';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../../../constants/logging';
import { jsx as _jsx } from "react/jsx-runtime";
const TOUR = {
  tourId: MARKETING_STUDIO_TOUR_ID,
  type: 'centralizedTour'
};
const OnboardingTour = ({
  isMarketingNavMenuOpen
}) => {
  const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
  const {
    startTour,
    stopTour,
    isActive
  } = useStartOnboardingTour(TOUR);

  // Adds a 2 second delay to stopTour to ensure the tour is visible for a while
  // when the user closes the marketing nav menu so they can interact with it
  const stopTourWithDelay = useCallback(() => {
    setTimeout(() => {
      stopTour().catch(error => {
        logger.error(new Error('error stopping tour:'), {
          cause: error
        });
      });
    }, 2000);
  }, [stopTour, logger]);

  // Starts and stops the tour when the user toggles the marketing nav menu
  useEffect(() => {
    if (isMarketingNavMenuOpen) {
      if (!isActive) {
        startTour().catch(error => {
          logger.error(new Error('error starting tour:'), {
            cause: error
          });
        });
      }
    } else {
      stopTourWithDelay();
    }

    // Stops the tour when the component unmounts
    return () => {
      if (isActive) {
        stopTourWithDelay();
      }
    };
  }, [isMarketingNavMenuOpen, startTour, stopTourWithDelay, isActive, logger]);
  return null;
};
export const MaybeMarketingStudioOnboardingTour = () => {
  const {
    openMenus
  } = useNavItems();
  const scopes = useAppSelector(selectScopes);
  const gates = useAppSelector(selectGates);
  const hasCampaignsReadAccess = useMemo(() => scopes.includes('campaigns-access'), [scopes]);
  const isUngatedForMarketingStudio = useMemo(() => gates.includes(MARKETING_STUDIO_GATE), [gates]);
  const isMarketingNavMenuOpen = useMemo(() => (openMenus === null || openMenus === void 0 ? void 0 : openMenus.primary) === 'marketing', [openMenus]);

  // Only render the tour component if the user has campaigns read access,
  // is ungated for marketing studio, and the marketing nav menu is open
  if (!hasCampaignsReadAccess || !isUngatedForMarketingStudio || !isMarketingNavMenuOpen) {
    return null;
  }
  return /*#__PURE__*/_jsx(OnboardingTour, {
    isMarketingNavMenuOpen: isMarketingNavMenuOpen
  });
};